<template>
  <base-panel :title="title" :titleIcon="titleIcon" @clickMore="handleClickMore" :id="id">
    <div class="article-list">
      <ArticleItem v-for="item in articleList" :key="item.fileId" :articleInfo="item" :isPC="isPC"></ArticleItem>
    </div>
  </base-panel>
</template>

<script>
import BasePanel from "../BasePanel"
import ArticleItem from "./ArticleItem"
import jumpArticle from "@/mixins/jumpArticle"

export default {
  name: "uiArticlePanel",
  props: {
    articleList: {
      type: Array,
      default() {
        return []
      }
    },
    titleIcon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    articlePanelInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    isPC: {
      type: Boolean,
      default: false
    }
  },
  mixins: [jumpArticle],
  methods: {
    handleClickMore() {
      this.jumpArticle({
        shareUrl: this.articlePanelInfo.shareUrl,
        jumpUrl: this.articlePanelInfo.jumpUrl
      })
      this.$emit("clickMore")
    }
  },
  components: {
    BasePanel,
    ArticleItem
  }
}
</script>

<style lang="scss" scoped>
.article-list {
  padding: 0.3rem 0;
}
.pc .article-list {
  padding: 20px 0 30px !important;
  display: flex;
  align-items: center;
}
</style>
